import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlusSquare, faTimes} from "@fortawesome/free-solid-svg-icons";

const Images = ({formData, setFormData}) => {

    const onAddImage = () => {
        setFormData({...formData, images: [...formData.images, {}] });
    }

    const onChangeImage = (e, index) => {
        let input = e.target;
        if (input.files && input.files[0]) {
            let reader = new FileReader();

            reader.onload = function (e2) {
                // e2.target.result
                setFormData({...formData, image: e2.target.result});
                setFormData({...formData, images:
                        formData.images.map((item, i) => i === index ?
                            {...item, path: e2.target.result} : item) });
            };

            reader.readAsDataURL(input.files[0]);
        }
    }

    const onRemoveImage = (index) => {
        setFormData({...formData, images: formData.images.filter((image, i) => i !== index)});
    }

    return (
        <div className="row">
            <div className="col-12">
                <label htmlFor="exampleInputEmail1" className="font-irs-b">تصاویر</label>
                <span className="text-success d-inline-block mr-1" onClick={onAddImage}>
                     <FontAwesomeIcon icon={faPlusSquare} size="lg" />
                </span>
            </div>

            {formData.images.map((image, index) => (
                <div className="col-3 text-center mt-2">
                    <div className="row align-items-center mb-1">
                        <div className="col">
                            <input type="file" className="form-control"
                                onChange={(e) =>
                                    onChangeImage(e, index)}
                            />
                        </div>
                        <div className="col-auto pr-0">
                            <span className="d-inline-block text-danger"
                                  onClick={() => onRemoveImage(index)}>
                                <FontAwesomeIcon icon={faTimes} size="lg"/>
                            </span>
                        </div>
                    </div>
                    <img src={image.path}
                         style={{maxWidth: '200px'}} className="img-responsive"/>
                </div>
            ))}
        </div>
    )
}
export default Images;
